import { Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { icons } from "../utils"

const data = [
  { value: "en", label: "English" },
  { value: "ru", label: "Русский" },
]

export function CompanyLocaleSelect(props: Partial<SelectProps>) {
  const { t } = useTranslation()
  return (
    <Select
      data={data}
      allowDeselect={false}
      label={t("Default language")}
      leftSection={<icons.Language />}
      {...props}
    />
  )
}
